import React from "react";
import { useCommentData } from "./CommentDataContext";
import "./TabHeader.css";

const TabHeader = () => {
  const {
    tabs,
    activeTab,
    setActiveTab,
    commentDetails,
    setseeAllDots,
    setrectangleMode,
    setisDotMode,
    setSelectedQuery
  } = useCommentData();

  return (
    <div className="tabheader-container">

      <div className="tabheader-tabs">
        {tabs.map((tab) => (
          <div key={tab} >
            <button
              className={`tabheader-tab ${
                activeTab === tab ? "active" : "inactive"
              }`}
              onClick={() => {
                setActiveTab(tab);
                window.canvasEngine.FeatureRenderer.clearCanvas();
                setrectangleMode(false);
                setisDotMode(false);
                setseeAllDots(false);
                setSelectedQuery(null);
                window.canvasEngine.FeatureRenderer.changeActiveTab(tab);
                setSelectedQuery(commentDetails?.[tab]?.at(-1) || null);
                // console.log(window.canvasEngine.FeatureRenderer.activeTab);
              }}
            >
              {tab}
            </button>

           
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabHeader;
